import { render, staticRenderFns } from "./GoogleCalendarConnect.vue?vue&type=template&id=873a5c5a&scoped=true&"
import script from "./GoogleCalendarConnect.vue?vue&type=script&lang=js&"
export * from "./GoogleCalendarConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873a5c5a",
  null
  
)

export default component.exports